import { useLocale } from "@dgs/core";
import { intlFormatDistance, isAfter, isBefore, parseISO, startOfDay } from "date-fns";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const DateTimeDurationDistance: FC<{ duration: { start: string; end: string } }> = ({
	duration: { start, end },
}) => {
	const { formatLocale } = useLocale();
	const { t } = useTranslation();
	const date = useMemo(() => startOfDay(new Date()), []);
	const currentlyRunning = isBefore(parseISO(start), date) && isAfter(parseISO(end), date);

	return currentlyRunning ? t("Running now") : intlFormatDistance(parseISO(start), date, { locale: formatLocale });
};
